import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { StorefrontCardView } from '@zola/svc-marketplace-ts-types';

import queryString from 'query-string';

import { storefrontCardViewToVendorCardVendor } from '~/components/common/cards/util/helper';
import { VendorLandingPageView } from '~/types/responseTypes';
import ApiService from '~/util/apiService';

export const getSmallVendorCardStorefront = (vendor: StorefrontCardView | null) => {
  if (vendor) {
    return {
      type: vendor.taxonomyNodeKey as VendorTaxonomyKey,
      name: vendor.name,
      vendorCard: storefrontCardViewToVendorCardVendor(vendor),
    };
  }

  return null;
};

export const fetchLandingPage = (params: { vendor_market_id: number }) => {
  const search = queryString.stringify(params);
  return ApiService.get<VendorLandingPageView>(
    `/web-marketplace-api/v1/marketplace/landing-page?${search}`
  );
};
